import Title from 'app/ui/display/Title';
import ScoreDisplay from 'app/ui/display/ScoreDisplay';
import HighScoreDisplay from 'app/ui/display/HighScoreDisplay';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import * as AppConstants from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

export default class HudGameIntro extends Phaser.Group {
  constructor({ game, message, onClose = false, onCloseScope = false }) {
    super(game);

    const messageData = this.game.controller.config.getIntroMessageById(message);

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.3 });
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    // // add main score
    this.copy = createTextField(this.game, AppConstants.FONT_COPY, 27, AppConstants.FONT_COLOUR_CREDITS);
    this.copy.text = this.game.copy.getCopy('developed_by').toUpperCase();
    this.copy.y = 50;
    this.copy.x = this.panel.width * 0.5 - this.copy.width * 0.5;
    this.container.add(this.copy);

    // add logo
    this.logo = this.game.make.image(0, 0, 'logo_jollywise');
    this.logo.anchor.set(0.5, 0);
    this.logo.x = this.panel.width / 2;
    this.logo.y = this.copy.y + this.copy.height;
    this.container.add(this.logo);

    // credits button
    this.btnClose = new ButtonSimple({ game: this.game, id: 'btn_continue', skin: 'btn_close' });
    this.btnClose.y = 0;
    this.btnClose.x = this.panel.width * 0.92;
    this.btnClose.onInputDown.add(this.handleClose, this);
    this.container.addChild(this.btnClose);

    // and we adjust the height of the panel to suit
    this.panel.height = this.logo.y + this.logo.height + 100;

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.fixedToCamera = true;
    this.handleScreenResize();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  /*
  ============================================================================================
    EVENT HANDLERS
  ============================================================================================
  */

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;
  }

  handleClose() {
    this.game.controller.closeGameCredits();
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    // clear listeners
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);
    this.btnClose.onInputDown.remove(this.handleClose, this);

    // destroy stuff
    this.btnClose.destroy(true);
    this.logo.destroy(true);
    this.panel.destroy(true);
    this.container.destroy(true);

    // nullify
    this.btnClose = null;
    this.logo = null;
    this.panel = null;
    this.container = null;

    // super dupa
    super.destroy(true);
  }
}
